<script>
// 竞赛规程
export default {
  props: {
    info: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    richTextContent() {
      if (!this.info || typeof this.info !== 'string') return ''
      let html = this.info
      // img 添加 width: 100%
      html = html.replace(/<img(\s[^>]*)>/gi, (match) => {
        if (/style\s*=\s*["']/i.test(match)) {
          return match.replace(/(style\s*=\s*["'])([^"']*)(["'])/i, (_, open, val, close) =>
            open + 'width:100%;max-width:100%;' + val + close
          )
        }
        return match.replace(/<img(\s*)/i, '<img style="width:100%;max-width:100%;"$1')
      })
      html = html.replace(/<img>/gi, '<img style="width:100%;max-width:100%;">')
      // p 标签添加 --font-color1 动态样式
      const fontColorStyle = 'color:var(--font-color1,#000);'
      html = html.replace(/<p(\s+[^>]*)>/gi, (match) => {
        if (/style\s*=\s*["']/i.test(match)) {
          return match.replace(/(style\s*=\s*["'])([^"']*)(["'])/i, (_, open, val, close) =>
            open + fontColorStyle + val + close
          )
        }
        return match.replace(/<p\s+/i, '<p style="' + fontColorStyle + '" ')
      })
      // p 标签无属性：<p>
      html = html.replace(/<p>/gi, '<p style="' + fontColorStyle + '">')
      return html
    }
  }
}
</script>
<template>
  <div class="regulations-container">
    <div class="regulations-content" v-html="richTextContent"></div>
  </div>
</template>
<style src="@/tbs/stylesheet/dynamic.css" />
